module.exports = __webpack_public_path__ + "img/chev-left.453f5fbb.svg";